import {AnyAction, createAsyncThunk, ThunkDispatch} from '@reduxjs/toolkit'

import {asyncActionWrapper} from '@web/helpers/api'

import apis from './apis'

type RootState = object

type ThunkApi<RejectValue = unknown> = {
    state: RootState
    dispatch: ThunkDispatch<RootState, unknown, AnyAction>
    rejectValue: RejectValue
}

export const registerOrderV1 = createAsyncThunk<
    {orderSheetId: string},
    {registerOrderKey: string; merchantId: string},
    ThunkApi
>('getRegisterOrderV1', ({registerOrderKey, merchantId}, {rejectWithValue}) => {
    return asyncActionWrapper(
        async () => {
            const response = await apis.registerOrderV1(registerOrderKey, merchantId)
            return response
        },
        {
            rejectWithValue,
        },
    )
})

export const registerOrderV2 = createAsyncThunk<
    {orderSheetId: string},
    {registerOrderKey: string; merchantNo: string},
    ThunkApi
>('getRegisterOrderV2', ({registerOrderKey, merchantNo}, {rejectWithValue}) => {
    return asyncActionWrapper(
        async () => {
            const response = await apis.registerOrderV2(registerOrderKey, merchantNo)
            return response
        },
        {
            rejectWithValue,
        },
    )
})
